/*
 * @Author: yaodongyi
 * @Date: 2025-06-26 21:48:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-06 15:30:56
 * @Description: 支付相关接口
 */
import request, { requestWithToken } from "../utils/request";
import Variable from "../utils/variable";

const GlobalVariable = new Variable().GlobalVariable;
const payConf = {
  API_BASE_URL: GlobalVariable.API_BASE_URL,
};
const Config = payConf;


/**
 * 获取独立支付信息
 * 判断逻辑流程图 https://img.lycheer.net/xupload/477/687dbd6587e183014de89a19.png
 */
export interface IGetDomainInfo {
  liveroom_id: number,
  // 直播间类型 （和直播间ID 二选一），当没有直播间id场景，传 choice_type
  choice_type?: "pgc" | "ugc"
  // 发起支付页面来源 （如果不传，用当前页面 window.location.origin）
  origin?: string,
  // 要查询的类型
  object_type?: 'category' | 'pay_channel' | string
  // 要查询类型对应的id
  object_id?: number,
}

// 获取独立支付信息返回结果
export interface IDomainInfo {
  // 是否需要为独立支付 true 为独立支付，false 为课内支付
  isIndependent: boolean
  // 独立支付需要跳转的域名, 没有值时为空字符串
  domain: string
}

/**
 * 获取独立支付信息
 * @param liveroom_id 直播间id
 * @param props 参数
 * @param onSuccess 成功回调 { isIndependent: boolean; domain: string }
 * @param onFailed 失败回调 错误信息
 */
export const api_getDomainInfo = (
  liveroom_id: any,
  props: { token: string; choice_type?: "pgc" | "ugc" },
  onSuccess: (data: IDomainInfo) => void,
  onFailed: (err: any) => void
) => {
  return request(
    {
      method: "POST",
      dataType: "json",
      baseUrl: Config.API_BASE_URL,
      url: "/api/pay/get_domain_info",
      query: { token: props.token },
      data: { liveroom_id, choice_type: props.choice_type },
    },
    (data) => {
      // 后端代码其实不会有非0的情况，这里避免后续后端扩展，先做好兼容
      if (data && data.code === 0 && data.data) {
        onSuccess({
          isIndependent: !!data.data.is_cashier_counter,
          domain: data.data.domain,
        });
      } else {
        onFailed(data);
      }
    },
    onFailed
  );
};

/**
 * 请求接口判断是否需要独立独立支付
 */
export async function api_getDomainInfoNew(
  params: IGetDomainInfo,
): Promise<IDomainInfo> {
  try {
    const TIMEOUT = 5000 // 请求超时时间
    // 使用 Promise.race 来处理超时
    const timeoutPromise = new Promise<never>((_, reject) => {
      setTimeout(() => {
        reject(new Error('TIMEOUT'));
      }, TIMEOUT);
    });
    const domainInfoPromise = requestWithToken<{
      data: {
        is_cashier_counter: boolean
        domain: string
      }
    }>(
      {
        method: 'POST',
        dataType: 'json',
        baseUrl: Config.API_BASE_URL,
        url: '/api/pay/get_domain_info_new',
        data: {
          // 默认是当前页面，支持外部传参覆盖。
          origin: window.location.origin,
          ...params,
        },
      },
      0,
    )
    const domainInfo = await Promise.race([domainInfoPromise, timeoutPromise])
    if (domainInfo && domainInfo.data) {
      return {
        isIndependent: !!domainInfo.data.is_cashier_counter,
        domain: domainInfo.data.domain,
      }
    } else {
      return Promise.reject({
        isIndependent: false,
        error: domainInfo,
      })
    }
  } catch (err) {
    throw {
      isIndependent: false,
      error: err,
    }
  }
}

/**
 * 预下单
 * @param params 支付参数（wx,pc,app等）
 * @param token 用户token
 */
export const api_preOrder = (params: { [key: string]: string | number }) => {
  return requestWithToken<{ data: { pay_hash_key: string }; code: number }>(
    {
      method: 'POST',
      dataType: 'json',
      baseUrl: Config.API_BASE_URL,
      url: '/api/pay/pre_order',
      data: { ...params },
    },
    0,
  )
}
